import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Home from 'src/components/home';
import Privacy from 'src/components/privacy';
import Error404 from 'src/components/404';
import { baseURL } from 'src/config';

export default (
	<Switch>
		<Route exact path={`${baseURL}/privacy`} component={Privacy} />
		<Route exact path={`${baseURL}/`} component={Home} />
		<Route path={`${baseURL}/index`} component={Home} />
		<Route path={`${baseURL}/`} component={Error404} />
	</Switch>
);



// WEBPACK FOOTER //
// ./src/routes.js